<template lang="pug">
.form-image.center
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section-x
      a.image-container-preview-large(:href="path" target="_blank")
        img.image-preview-large(:src="path" :alt="dataForm.image" :class="getWidth()")
      .input-container
        label.label.capitalize Size
        input.input(:value="`Width: ${size.width}px * Height: ${size.height}px`" autocomplete="ño" :disabled="fillData" required)
      .input-container
        label.label.capitalize Image
        input.input(v-model="dataForm.image" autocomplete="ño" :disabled="fillData" required)
      .input-container
        label.label.capitalize Ruta
        input.input(v-model="dataForm.dir" autocomplete="ño" :disabled="fillData" required)
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gqlImage from '@/graphql/image'
import shDeleteButton from '@/components/elements/DeleteButton'

export default {
  name: 'FormImage',

  mixins: [mForm, mFilters, mDB],

  components: { shDeleteButton },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object,
    path: String,
    size: Object
  },

  data () {
    return {
      dataForm: {
        image: '',
        folder: '',
        subfolder: ''
      },
      resolver: 'image',
      key: 'dir',
      gql: gqlImage
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    deleteImage () {
      this.deleteData(this.gql, this.resolver, this.key)
    },
    getWidth () {
      if (this.size.height > this.size.width) {
        const proportion = this.size.height / this.size.width

        if (proportion >= 0 && proportion < 2) return ''
        if (proportion >= 2 && proportion < 4) return 'width10'
        return 'width10'
      }
    }
  }
}
</script>

<style lang="stylus">
.form-image
  position relative

.image-preview-large
  width 60%
  max-width 50em
  margin-bottom 1em

.width30
  width 30%

.width10
  width 10%

.width5
  width 5%
</style>



// WEBPACK FOOTER //
// src/components/pages/image/Form.vue